<template>
    <div 
        class="details-container"
        :style="{ 'background-image': 'url(' + PodBG + ')' }"
    >
        <!-- Header -->
        <div class="header">
            <div 
                class="inner-color"
                :style="{ 'background-image': 'linear-gradient(180deg, #ffffffbf, #ffffffbf), url(' + URL + '/' + response.Cover + ')' }"
            >
                <img @click="back" class="back" :src="Back" alt="Back">  
                <i @click="showInfo" class="far fa-info-circle pod-info"></i>

                <div class="play-img-container">
                    <img class="podcast-disk" :src="Disk" alt="Disk">

                    <img class="handle-disk" v-if="play" :src="PlayImg" alt="Play">
                    <img class="handle-disk" v-else :src="StopImg" alt="Play">
                </div>

                <h6 class="podcast-title">{{ response.Title }}</h6>

                <br>
                <audio 
                    nocontrols
                    class="podcast-audio"
                    controlsList="nodownload nofullscreen"
                    :key="fileId"
                    id="podcastAudio"
                >
                    <source 
                        id="track"
                        type="audio/mpeg"
                        v-if="response.File" 
                        :src="URL + '/' + response.File" 
                    >
                    Your browser does not support the audio element.
                </audio>

                <div class="progress container">
                    <div 
                        id="progressBar"
                        class="progress-bar bg-warning" 
                        role="progressbar" aria-valuemin="0" aria-valuemax="100"
                    ></div>

                    <input id="progressRange" type="range" :value="range" @input="changeRange($event.target.value)" max="100"/>
                </div>
                <div class="timer container" v-if="duration && curTime">
                    <span v-if="duration.days() > 0">{{ 
                        duration.days()* 24 + duration.hours() + ':' + 
                        ("0" + duration.minutes()).slice(-2) + ':' + 
                        ("0" + duration.seconds()).slice(-2)
                    }}</span>
                    <span v-else>{{ 
                        ("0" + duration.hours()).slice(-2) + ':' + 
                        ("0" + duration.minutes()).slice(-2) + ':' + 
                        ("0" + duration.seconds()).slice(-2)
                    }}</span>

                    <span v-if="curTime.days() > 0">{{ 
                        curTime.days()* 24 + curTime.hours() + ':' + 
                        ("0" + curTime.minutes()).slice(-2) + ':' + 
                        ("0" + curTime.seconds()).slice(-2)
                    }}</span>
                    <span v-else>{{ 
                        ("0" + curTime.hours()).slice(-2) + ':' + 
                        ("0" + curTime.minutes()).slice(-2) + ':' + 
                        ("0" + curTime.seconds()).slice(-2)
                    }}</span>
                </div>

                <div class="icon-row">
                    <i v-if="liked" class="fas fa-heart icon-font unlike-pod" @click="removePod"></i>
                    <i v-else class="fas fa-heart icon-font like-pod" @click="addPod"></i>

                    <i @click="Play(false)" v-if="play" style="width: 40%" class="fas fa-pause icon-font"></i>
                    <i @click="Play(true)" v-else style="width: 40%" class="fas fa-play icon-font"></i>

                    <i @click="Mute(false)" v-if="mute" class="fas fa-volume-mute icon-font"></i>
                    <i @click="Mute(true)" v-else class="fas fa-volume-up icon-font"></i>
                </div>
            </div>

            <div class="info-box" v-if="show">
                <i @click="closeInfo" class="fal fa-times-circle pod-info"></i>

                <h6>{{ response.Title }}</h6>
                <p>{{ response.Desc | truncateText(350) }}</p>

                <img class="podcast-timer" :src="Timer" alt="Timer">
                <p v-if="duration.days() > 0" class="duration">مدت زمان: {{ 
                    duration.days()* 24 + duration.hours() + ':' + 
                    ("0" + duration.minutes()).slice(-2) + ':' + 
                    ("0" + duration.seconds()).slice(-2)
                }}</p>
                <p v-else class="duration">مدت زمان: {{ 
                    ("0" + duration.hours()).slice(-2) + ':' + 
                    ("0" + duration.minutes()).slice(-2) + ':' + 
                    ("0" + duration.seconds()).slice(-2)
                }}</p>
            </div>
        </div>

        <!-- FAVORITE POSTs -->
        <FavoritePodcasts :resultList="resultList"></FavoritePodcasts>
    </div>
</template>

<script>
import Sandoghche from '@/assets/images/resaneh/sandoghche_gray.png';

import Back from '@/assets/images/courses/video-details/back.png';
import PodBG from '@/assets/images/resaneh/pod-bg.png';
import Disk from '@/assets/images/resaneh/disk.png';
import StopImg from '@/assets/images/resaneh/stop.png';
import PlayImg from '@/assets/images/resaneh/play.png';
import Timer from '@/assets/images/resaneh/timer.png';

import FavoritePodcasts from '@/components/FavoritePodcasts';

import { getRequest, postRequest, APP_API_URL } from '@/utils/libs/api-request';
import moment from 'moment-jalaali';
import Cookies from 'js-cookie';

export default {
    name: 'PodcastDetails',
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.prevRoute = from
        })
    },
    components: {
        FavoritePodcasts
    },
    data() {
        return {
            Back: Back,
            Disk: Disk,
            StopImg: StopImg,
            PlayImg: PlayImg,
            Timer: Timer,
            PodBG: PodBG,

            Sandoghche: Sandoghche,

            range: 0,
            duration: moment.duration(0, 'seconds'),
            curTime: moment.duration(0, 'seconds'),

            URL: APP_API_URL(),
            prevRoute: {},
            show: false,
            play: false,
            mute: false,

            fileId: this.$route.params.id,
            response: {},
            resultList: [],
            liked: false,
        }
    },
    watch: {
        '$route': {
            handler: function() {
                this.GetFavs();
                this.GetUser();
                this.GetPodcast();

                this.liked = false;
            },
            immediate: true
        },
    },
    methods: {
        changeRange(value) {
            this.Play(false)
            let aud = document.getElementById('podcastAudio');
            aud.currentTime = (value / 100) * aud.duration;
            this.Play(true)
        },
        Play(state) {
            let aud = document.getElementById('podcastAudio');
            if(state) aud.play();
            else aud.pause()

            let progressBar = document.getElementById('progressBar');
            this.duration = moment.duration(aud.duration, 'seconds');

            aud.ontimeupdate = (function(){
                progressBar.style.width = ((aud.currentTime / aud.duration) * 100) + '%';
                this.range = ((aud.currentTime / aud.duration) * 100)
                this.curTime = moment.duration(aud.currentTime, 'seconds');
            }).bind(this)
            
            this.play = state;
        },
        removePod() {
            postRequest('/users/unbook-items', {
                isPodcast: true,
                itemId: this.$route.params.id
            })
                .then(() => {
                    // response
                    this.liked = false;
                })
                .catch(() => {
                    // error
                });
        },
        addPod() {
            postRequest('/users/book-items', {
                isPodcast: true,
                itemId: this.$route.params.id
            })
                .then(() => {
                    // response
                    this.liked = true;
                })
                .catch(() => {
                    // error
                });
        },
        Mute(state) {
            document.getElementById('podcastAudio').muted = state;
            this.mute = state;
        },
        closeInfo() {
            this.show = false;
        },
        showInfo() {
            this.show = true;
        },
        GetFavs() {
            getRequest('/podcasts/find-favorites', {})
                .then((rsp) => {
                    // response
                    this.resultList = rsp['data']
                })
                .catch(() => {
                    // error
                });
        },
        GetUser() {
            getRequest('/users/user')
                .then(rsp => {
                    // response
                    let list = rsp['data'].BookedPodcasts;
                    list.forEach(elm => {
                        if(elm == this.$route.params.id) this.liked = true;
                    });
                })
                .catch(() => {
                    // error
                });
        },
        GetPodcast() {
            getRequest('/podcasts/find-one', { 
                id: this.$route.params.id
            })
                .then(rsp => {
                    // response
                    let data = rsp.data;
                    this.response = data;

                    this.fileId = this.$route.params.id;

                    setTimeout((() => {
                        let aud = document.getElementById('podcastAudio');

                        if(aud.duration) {
                            this.duration = moment.duration(aud.duration, 'seconds');
                        }
                        else this.duration = moment.duration(data.Duration, 'seconds');
                    }).bind(this), 100)
                })
                .catch(err => {
                    // check auth
                    if (err.response) {
                        if (err.response.status == 401) {
                            Cookies.remove('access_cookie');
                            this.$router.push({ name: 'Login' });
                        }
                    }
                });
        },
        back() {
            if(this.prevRoute.name) {
                this.$router.go(-1)
            } else {
                this.$router.push({ name: 'Khanesh' })
            }
        }
    },
}
</script>

<style scoped>
/* ---------------------------------------- */
/* ---------------- HEADER ---------------- */
/* ---------------------------------------- */
.details-container {
    min-height: 100vh;
    background-color: #fa6b0b;

    position: relative;
    overflow: hidden;

    display: flex;
    flex-direction: column;

    background-size: 100% calc(40vh + 35pt);
    background-repeat: no-repeat;
    background-position: center bottom;
} 
.details-container .progress {
    height: fit-content;
    margin-bottom: 1rem;
    margin-top: -.5rem;

    padding-left: 0;
    padding-right: 0;

    direction: ltr;
    position: relative;

    overflow: visible;
}
.details-container #progressBar {
    margin: -5px 0;
    position: relative;
    z-index: 1;
    border-radius: 5pt;
}
.details-container .timer {
    display: flex;
    flex: row;

    margin-bottom: .5rem;
}
.details-container .timer span {
    display: inline-block;
    margin: auto;
}
.details-container .timer span:first-child {
    margin-right: 0;
}
.details-container .timer span:last-child {
    margin-left: 0;
}
.details-container #progressRange {
    width: 100%;
    position: absolute;
    z-index: 2;
}
.details-container .like-pod,
.details-container .unlike-pod{
    font-size: 1.5rem !important;
}
.details-container .like-pod {
    color: #86888e;
}
.details-container .unlike-pod {
    color: #f10000;
}

/* range color */
input[type=range] {
  height: 0;
  -webkit-appearance: none;
  background: #ddd;
  margin: 0;
  width: 100%;
}
input[type=range]:focus {
  outline: none;
}
input[type=range]::-webkit-slider-runnable-track {
  width: 100%;
  height: 10px;
  cursor: pointer;
  box-shadow: 1px 1px 1px #000000;
  background: #FEDD08;
  border-radius: 5px;
  border: 1px solid #000;
}
input[type=range]::-webkit-slider-thumb {
  box-shadow: 1px 1px 1px #856C01;
  border: 1px solid #6E5901;
  height: 20px;
  width: 20px;
  border-radius: 20px;
  background: #FECE02;
  cursor: pointer;
  -webkit-appearance: none;
  margin-top: -6px;
}
input[type=range]:focus::-webkit-slider-runnable-track {
  background: #FEDD08;
}
input[type=range]::-moz-range-track {
  width: 100%;
  height: 10px;
  cursor: pointer;
  box-shadow: 1px 1px 1px #000000;
  background: #FEDD08;
  border-radius: 5px;
  border: 1px solid #000;
}
input[type=range]::-moz-range-thumb {
  box-shadow: 1px 1px 1px #856C01;
  border: 1px solid #6E5901;
  height: 20px;
  width: 20px;
  border-radius: 20px;
  background: #FECE02;
  cursor: pointer;
}
input[type=range]::-ms-track {
  width: 100%;
  height: 10px;
  cursor: pointer;
  background: transparent;
  border-color: transparent;
  color: transparent;
}
input[type=range]::-ms-fill-lower {
  background: #FEDD08;
  border: 1px solid #000;
  border-radius: 10px;
  box-shadow: 1px 1px 1px #000000;
}
input[type=range]::-ms-fill-upper {
  background: #FEDD08;
  border: 1px solid #000;
  border-radius: 10px;
  box-shadow: 1px 1px 1px #000000;
}
input[type=range]::-ms-thumb {
  margin-top: 1px;
  box-shadow: 1px 1px 1px #856C01;
  border: 1px solid #6E5901;
  height: 20px;
  width: 20px;
  border-radius: 20px;
  background: #FECE02;
  cursor: pointer;
}
input[type=range]:focus::-ms-fill-lower {
  background: #FEDD08;
}
input[type=range]:focus::-ms-fill-upper {
  background: #FEDD08;
}

/* header */
.details-container .header {
    height: 60vh;
    width: 100vw;

    position: relative;
    overflow: hidden;

    color: #666;
}
.details-container .header .pod-info,
.details-container .header .back {
    position: absolute;
    top: 10pt;

    cursor: pointer;
}
.details-container .header .back {
    height: 2rem;
    right: 10pt;
}
.details-container .header .pod-info {
    left: 10pt;
    font-size: 2rem;
}
.details-container .header .inner-color {
    display: flex;
    flex-direction: column;

    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
}
.details-container .header .inner-color .icon-row {
    display: flex;
    flex-direction: row-reverse;
}
.details-container .header .inner-color .icon-column {
    width: 30%;
    margin: auto;

    display: flex;
    flex-direction: column;

    font-size: .75rem;
    text-align: center;
}
.details-container .header .inner-color .icon-img {
    height: 1.25rem;
    width: 1.25rem;
    margin: 0 auto .25rem;
}
.details-container .header .inner-color .icon-font {
    width: 30%;
    margin: auto;

    text-align: center;
    font-size: 3rem;
}
.details-container .header .play-img-container {
    max-width: 60%;
    max-height: 20vh;
    margin: 5vh auto calc(20vh + 15pt);
    
    display: flex;
    flex-direction: row;
    position: relative;
}
.details-container .header .handle-disk,
.details-container .header .podcast-disk {
    max-width: 60vw;
    max-height: 20vh;

    position: absolute;
}
.details-container .header .podcast-disk {
    top: 0;
    left: -10vh;
}
.details-container .header .handle-disk {
    top: -2.5vh;
    left: -20vh;
}
.details-container .header .podcast-title {
    text-align: center;
    margin-bottom: 0;
}
.details-container .header .podcast-audio {
    width: 90%; 
    margin: 0 auto;
}
@media (max-width: 576px) {
    .details-container .header .podcast-title {
        top: calc(5pt + .75rem);
    }
}

/* info box */
.details-container .header .info-box,
.details-container .header .inner-color {
    height: 100%;
    width: 100%;
    padding: 20pt 15pt 10pt;

    border-bottom-left-radius: 50pt;
    border-bottom-right-radius: 50pt;
}
.details-container .header .info-box {
    padding-top: 40pt;
    background-color: #373b48;
    z-index: 1;

    position: absolute;
    top: 0;
    opacity: .9;

    display: flex;
    flex-direction: column;
}
.details-container .header .inner-color {
    background-color: #f1f2f6;
}
.details-container .header .info-box .pod-info {
    color: #f1f2f6;
}
.details-container .header .info-box .podcast-timer {
    width: 25pt;
    margin: 0 auto 1rem;
}
.details-container .header .info-box .duration {
    margin: 0 auto;
    font-weight: bold;
    color: #f1f2f6;
}
.details-container .header .info-box h6 {
    color: #fece02;
    text-align: center;
}
.details-container .header .info-box p {
    color: #bbbbbc;
}
@media (max-width: 576px) {
    .details-container .header .info-box p {
        font-size: 80%;
    }
}
</style>